import { ALERTS_NOTIFICATION } from '@rsos/capstone/src/constants/capabilities';

/**
 * Function to determine if the current user's authority has the
 * `alerts_notification` capability turned on
 * @param {Object} psaps - PSAPS reducer
 */
const isAlertsNotificationEnabled = psaps => {
  return !!psaps.currentPSAP?.activeCapabilities?.[ALERTS_NOTIFICATION];
};

export default isAlertsNotificationEnabled;
